import React from 'react';
import { Reveal } from './Reveal';
import { levelTags } from '../data/content';
export function BrandReveal() {
  return <section className="w-full bg-white px-5 py-20 sm:px-8" data-id="element-35" data-mp="3ufm09tb95yxl">
      <div className="mx-auto w-full max-w-5xl text-center" data-id="element-36" data-mp="3qek97zrhot6p">
        <Reveal data-id="element-37" data-mp="3qf268ylz7bfo">
          <p className="inline-block rounded-full bg-gold px-4 py-1.5 text-2xs font-bold uppercase tracking-widest text-navy" data-id="element-38" data-mp="3qcfuems1y9rn">
            The complete system for flag football coaches
          </p>

          <h2 className="mt-8 font-display text-4xl font-black uppercase leading-[1.05] tracking-tight text-navy sm:text-5xl md:text-7xl" data-id="element-39" data-mp="ly9aw8xlheos">
            Flag Football <span className="text-brand-strong" data-id="element-40" data-mp="cymanqglqexb">Ready</span>
          </h2>

          <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-navy/70 sm:text-lg" data-id="element-41" data-mp="81cgjxi9pf35">
            10 volumes, 600 pages, session plans, playbooks, drill banks, PE units and
            season tools. <strong className="font-bold text-navy" data-id="element-42" data-mp="2sqsb93klxny2">Everything ready.</strong>
          </p>
        </Reveal>

        <Reveal delay={0.08} data-id="element-43" data-mp="1aegayncdi4wu">
          <ul aria-label="Levels covered" className="mt-10 flex flex-wrap items-center justify-center gap-3" data-id="element-44" data-mp="1ae6imt3uvlnz">
            {levelTags.map(tag => <li key={tag} className="rounded-full border border-turf/30 bg-turf/10 px-4 py-2 text-sm font-semibold text-navy" data-id="element-45" data-mp="10efqgy2rpir2">
                {tag}
              </li>)}
          </ul>
        </Reveal>
      </div>
    </section>;
}